import { render } from "./BlogPageTwo.vue?vue&type=template&id=4b1fecc4"
import script from "./BlogPageTwo.vue?vue&type=script&lang=js"
export * from "./BlogPageTwo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\digitaldistribution.io-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__